import { IBundleResolver } from '../index';
import { NotFoundBundleByResolver } from '../../errors';
import { SystemLogger } from '../../util/SystemLogger';

type Manifest = { [key: string]: string };

export class StaticBundleResolver<BundleName extends string> implements IBundleResolver<BundleName> {
  private manifestPromise?: Promise<Manifest>;
  private manifest?: Manifest;

  constructor(private url: string) {}

  resolve<K extends BundleName>(bundleName: K): Promise<string> {
    return this.getManifest().then(manifest => {
      const bundleFileName = bundleName.replace(/^bundle\//, '') + '.js';
      const bundleFileNameWin = bundleFileName.replace(/\//g, '\\');
      if (!manifest[bundleFileName] && !manifest[bundleFileNameWin]) {
        throw new NotFoundBundleByResolver(bundleName);
      }
      return (process.env.PUBLIC_URL || '') + '/' + (manifest[bundleFileName] || manifest[bundleFileNameWin]);
    });
  }

  reset(): void {
    this.manifest = undefined;
    this.manifestPromise = undefined;
  }

  private getManifest(): Promise<Manifest> {
    if (this.manifest) {
      return Promise.resolve(this.manifest);
    }
    if (this.manifestPromise) {
      return this.manifestPromise;
    }
    // We add Date.now() to the url to prevent cache.
    this.manifestPromise = fetch(this.url + `?v=${Date.now()}`)
      .then(response => response.json())
      .then(manifest => {
        SystemLogger.debug('[MANIFEST] :');
        SystemLogger.debug(manifest);
        this.manifest = manifest;
        return manifest;
      });
    return this.manifestPromise;
  }
}



// WEBPACK FOOTER //
// ./node_modules/front-system/engine/resolver/static/index.ts